import type { RootState } from "../store"

export const reportSavedFiltersSelector = (state: RootState) =>
    state.reportSavedFilters
